// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_HsoZG","foot_link":"index_foot_link_QOv-3","list":"index_list_kv2SY","link":"index_link_reWm-","copyright":"index_copyright_iPHBT"};